stateTagApp.log(stateTagApp.namespace.concat("-html: #BUILD#"));

import _ from "lodash";
import Vue from "vue";
import vueCustomElement from "vue-custom-element";
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

stateTagApp.Vue = Vue;
stateTagApp.env = process.env.NODE_ENV;

Vue.use(vueCustomElement);
Vue.use(require("vue-moment"));

const swalOptions = {
    confirmButtonColor: '#41b882',
    cancelButtonColor: '#ff7674',
    allowOutsideClick: false,
};
Vue.use(VueSweetalert2, swalOptions);
stateTagApp['alert'] = Vue.swal;

Vue.config.productionTip = {
    production: true,
    development: false
}[process.env.NODE_ENV];

Vue.prototype._ = _;
import {v4 as uuidv4} from 'uuid';

stateTagApp['uuid'] = uuidv4;

stateTagApp['api'] = stateTagApp['api'][process.env.NODE_ENV];
import Api from "./api";

import Nebula from "./nebula";

Vue.use(Nebula);

Vue.use(Api);

import VueSocketIOExt from 'vue-socket.io-extended';
import io from 'socket.io-client';

if (!_.isUndefined(stateTagApp.socket)) {
    stateTagApp.socket = stateTagApp.socket[process.env.NODE_ENV];
    stateTagApp['socketIo'] = io(stateTagApp.socket);

    stateTagApp['$onSocket'] = function (event, handler) {
        stateTagApp['socketIo'].on(event, handler);
    }

    Vue.use(VueSocketIOExt, stateTagApp['socketIo']);
}

Vue.filter("date", function (value, format) {
    format = format || stateTagApp.format.date;
    let date = new Date(value);
    return stateTagApp.Vue.moment(date).format(format)
});

Vue.filter("obfuscate", function (value) {
    let level = stateTagApp.commands.getLevel();
    
    if (level.obfuscate) {
        return '';
    }
    return value;
});

Vue.filter("number", function (value) {

    value = Number(value);
    return value.toLocaleString('us');
});

Vue.filter("bullet", function (value) {
    return "".concat(value)
        .replace(/\./g, "&bull;");
});

Vue.filter("time", function (seconds) {

    var hours = Math.floor(seconds / 3600);
    var minutes = Math.floor((seconds - (hours * 3600)) / 60);
    var seconds = seconds - (hours * 3600) - (minutes * 60);

    if (hours < 10) {
        hours = "0" + hours;
    }
    if (minutes < 10) {
        minutes = "0" + minutes;
    }
    if (seconds < 10) {
        seconds = "0" + seconds;
    }
    return /*hours+':'+*/minutes + ':' + seconds;
});

Vue.filter('dynamicFilters', function (value, filters) {

    for (let i in filters) {
        let name = filters[i].name;
        let args = filters[i].args || [];
        value = Vue.filter(name)(value, ...args);
    }

    return value;
});

initGlobalStateWatchers(stateTagApp["storage"]);
initGlobalSocketWatchers();
initGlobalNebulaWatchers(uuidv4, _);

import XHtml from "./x-html";

Vue.use(XHtml);
import Manifest from "@/x-html/manifest";

import state from "./state";

import router from "./routes"

for (let tag in Manifest) {
    Manifest[tag].store = state;
    Manifest[tag].router = router;
    Vue.customElement(tag, Manifest[tag]);
}



